<div *ngIf="(userCreditcard.creditCardNumber && updateExistingCard==false) && !newCard">
    <div class="mb-3">
        <div class="card-header py-0 align-items-center d-flex">
            <h4 class="card-title mb-0 flex-grow-1" i18n="@@">
                <span *ngIf="userCreditcard.creditCardNumber else elseAddCard" >
                    Current Card
                </span>
                <ng-template #elseAddCard>
                    <span>
                        Add Credit Card
                    </span>
                </ng-template>  
            </h4>
            <div style="text-align: end; top:-0.5rem; position:relative;">
                <button *ngIf="showUpdate" class="btn badge bg-light text-primary fs-12" style="text-align: center; "
                    style="text-align: center; " (click)="updateCard()">
                    <div style="display: inline-flex; ">
                        <i class="ri-edit-box-line align-bottom me-1"></i>
                        <div style="text-align: center;" i18n="@@Common_Edi">Update Card</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div class="row g-2">
        <div class="col-md-6">
            <label class="form-label" i18n="@@UpdateProfile_PaymentInfo_NameOnCard">Name on card</label>
            <input [disabled]="true" class="form-control" type="text" [(ngModel)]="userCreditcard.cardHolderName" />
        </div>
        <div class="col-md-6">
            <label class="form-label" i18n="@@UpdateProfile_PaymentInfo_CardNumbers">Credit Card Number</label>
            <input [disabled]="true" class="form-control" type="text" [(ngModel)]="cardEnding" />
        </div>
    </div>
</div>

<div *ngIf="(updateExistingCard || newCard)">
    <div class="card-header align-items-center d-flex mb-2">
        <h4 class="card-title mb-0 flex-grow-1" i18n="@@">
            <span *ngIf="(userCreditcard.creditCardNumber && !newCard) else elseAddCard">
                Update Credit Card
            </span>
            <ng-template #elseAddCard>
                <span>
                    Add Credit Card
                </span>
            </ng-template>  
        </h4>
    </div>
    <div class="row g-2">
        <div class="col-md-6">
            <label class="form-label" i18n="@@UpdateProfile_PaymentInfo_NameOnCard">Name on card</label>
            <input required #name="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (name.invalid && ((name.dirty || name.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="userCreditcard.cardHolderName" placeholder="Enter Name"
                i18n-placeholder="@@Common_EnterFullName" />
            <small class="text-muted" i18n="@@UpdateProfile_PaymentInfo_EnterFullNameAsDisplayed">Full name as displayed
                on card</small>
            <div *ngIf="name.invalid && ((name.dirty || name.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'>
                <!-- this is the style of form-invalid -->
                <div *ngIf="name.errors?.['required']">
                    <div i18n="@@">Full Name is Required</div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-label" i18n="@@UpdateProfile_PaymentInfo_CardNumbers">Credit Card Number</label>
            <input required #ccNum="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (ccNum.invalid && ((ccNum.dirty || ccNum.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="userCreditcard.creditCardNumber"
                mask="0000 0000 0000 0009" placeholder="xxxx xxxx xxxx xxxx" i18n-placeholder="@@"
                [dropSpecialCharacters]="false" />
            <div *ngIf="ccNum.invalid && ((ccNum.dirty || ccNum.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'>
                <!-- this is the style of form-invalid -->
                <div *ngIf="ccNum.errors?.['required'] else elseNum">
                    <div i18n="@@">Credit Card Number Required</div>
                </div>
                <ng-template #elseNum>
                    <div *ngIf="ccNum.invalid">
                        <div i18n="@@Error_creditCardNumberPatern">Credit card number needs to be 15 or 16 numbers long.
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="col-md-3">
            <label class="form-label" i18n="@@UpdateProfile_PaymentInfo_Expiration">Expiration</label>
            <input required #expireDate="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (expireDate.invalid && ((expireDate.dirty || expireDate.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="userCreditcard.expiryDate" placeholder="MM/YY"
                i18n-placeholder="@@UpdateProfile_PaymentInfo_ExpirationFormat" mask="00/00"
                [dropSpecialCharacters]="false" />
            <div *ngIf="expireDate.invalid && ((expireDate.dirty || expireDate.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'>
                <!-- this is the style of form-invalid -->
                <div *ngIf="expireDate.errors?.['required'] else elseDate">
                    <div i18n="@@">Expiration Date Required</div>
                </div>
                <ng-template #elseDate>
                    <div *ngIf="expireDate.invalid">
                        <div i18n="@@Error_creditCardExpirationPatern">Expiration Invalid</div>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="col-md-3">
            <label class="form-label" i18n="@@UpdateProfile_PaymentInfo_CVV">CVV*</label>
            <input required #cvv="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (cvv.invalid && ((cvv.dirty || cvv.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="userCreditcard.cvvNumber" placeholder="CVV"
                i18n-placeholder="@@UpdateProfile_PaymentInfo_CVVFormat" mask="0009" [dropSpecialCharacters]="false" />
            <div *ngIf="cvv.invalid && ((cvv.dirty || cvv.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'>
                <!-- this is the style of form-invalid -->
                <div *ngIf="cvv.errors?.['required']  else elseCVV">
                    <div i18n="@@">CVV Required</div>
                </div>
                <ng-template #elseCVV>
                    <div *ngIf="cvv.invalid">
                        <div i18n="@@Error_creditCardCVVPatern">CVV Invalid</div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div *ngIf="showUpdate"  class="d-flex mt-3 justify-content-end" >
        <button class="btn btn-soft-primary" (click)=saveCard()> 
            <span *ngIf="updateExistingCard else elseAddCard">
                Update Credit Card
            </span>
            <ng-template #elseAddCard>
                <span>
                    Add Credit Card
                </span>
            </ng-template>  
        </button>
    </div>
</div>